import { memo, useCallback, useEffect, useRef } from "react";
import { Button, Loader, PageHeader, Text, useTheme, type ModalRef } from "react-better-html";

import { useI18n } from "../../../utils/i18n";
import { useReduxAction, useReduxState } from "../../../utils/hooks";

import PropertiesWorkspacesList from "../../../components/PropertiesWorkspacesList";
import WorkspaceModal from "../../../components/modals/WorkspaceModal";

function Workspaces() {
   const theme = useTheme();
   const { t } = useI18n();

   const workspaceModalRef = useRef<ModalRef>(null);

   const workspacesList = useReduxState((state) => state.workspaces.list);

   const getAllWorkspaces = useReduxAction((actions) => actions.workspaces.getAllWorkspaces);

   const onClickCreate = useCallback(() => {
      workspaceModalRef.current?.open();
   }, []);

   useEffect(() => {
      getAllWorkspaces();
   }, []);

   return (
      <>
         <PageHeader
            title={t((l) => l.pages.workspaces.title)}
            titleAs="h2"
            titleRightElement={
               workspacesList ? (
                  <Text
                     fontSize={14}
                     color={theme.colors.textSecondary}
                  >{`${workspacesList.length} ${t((l) => (workspacesList.length === 1 ? l.common.workspace : l.common.workspaces))}`}</Text>
               ) : (
                  <Loader.text fontSize={14} size={10} />
               )
            }
            rightElement={<Button icon="plus" text={t((l) => l.common.create)} onClick={onClickCreate} />}
            marginBottom={theme.styles.space}
         />

         <PropertiesWorkspacesList workspaces={workspacesList} />

         <WorkspaceModal ref={workspaceModalRef} />
      </>
   );
}

export default memo(Workspaces);
